import React from 'react'
import { CFooter } from '@coreui/react'

const MembersFooter = () => {
  return (
    <CFooter className="p-4">
      <div>
        <a href="https://kpca.or.ke" target="_blank" rel="noopener noreferrer">
          KPCA Portal
        </a>
        <span className="ms-1">&copy; {new Date().getFullYear()} Kenya Professional Cleaning Association.</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Designed and Developed by:</span>
        <a href="https://leal.co.ke" target="_blank" rel="noopener noreferrer">
          Lembur East Africa Limited
        </a>
      </div>
    </CFooter>
  )
}

export default MembersFooter 